"use client";

import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import { useTranslations } from "next-intl";
import { Button } from "@/ui/button";

export function ErrorContent({
  error: _error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations("error");
  return (
    <div className="mx-auto flex max-w-xl flex-col items-center gap-6 px-6 py-24 text-center">
      <ExclamationTriangleIcon
        className="size-10 text-ui-fg-muted"
        aria-hidden
      />
      <h1 className="text-2xl font-semibold text-ui-fg">{t("title")}</h1>
      <p className="text-sm text-ui-fg-muted">{t("description")}</p>
      <Button onClick={reset}>{t("retry")}</Button>
    </div>
  );
}
